<body>
  <div *ngIf="!this._router.url.includes('RefineryHome')" class="hambergerIcon"></div>
  <app-nav-bar [data]="globals.userEmail"></app-nav-bar>
  <mat-sidenav-container>
    <mat-sidenav-content>
      <main>
        <router-outlet></router-outlet>
      </main>
    </mat-sidenav-content>
  </mat-sidenav-container>

</body>
